// Updated 21-09 Midnight
document.addEventListener('DOMContentLoaded', () => {
    const tabsContainer = document.querySelector('.mr-pp-tabs');
    if (tabsContainer) {
        let firstHeader = tabsContainer.querySelector('h5');
        let initialContentContainer;

        // Get the customizable title from Shopify (replace this with the actual Shopify Liquid setting or hidden element)
        const descriptionTitle = document.getElementById('description-translation') ? document.getElementById('description-translation').innerText : 'Custom Title';

        // Automatically add a <span> to every <h5> within .mr-pp-tabs
        document.querySelectorAll('.mr-pp-tabs h5').forEach(header => {
            const span = document.createElement('span');
            span.classList.add('symbol');
            span.textContent = '+';
            header.prepend(span);
        });

        // Check if there's content before the first <h5> and if the first <h5> exists
        let firstChild = tabsContainer.firstChild;
        let contentBeforeHeaderExists = false;

        while (firstChild && firstChild !== firstHeader) {
            if (firstChild.nodeType === 3 && firstChild.textContent.trim().length > 0) {
                // If there's a text node with content before the first <h5>, mark it
                contentBeforeHeaderExists = true;
                break;
            } else if (firstChild.nodeType === 1 && firstChild.nodeName !== 'H5') {
                // If there's an element node that's not <h5>, mark it as content before the header
                contentBeforeHeaderExists = true;
                break;
            }
            firstChild = firstChild.nextSibling;
        }

        // If content exists before the first <h5>, create a new <h5> tag with the customizable title
        if (contentBeforeHeaderExists) {
            // Create the new <h5> element with a custom title
            const newHeader = document.createElement('h5');
            newHeader.innerHTML = `<span class="symbol">+</span> ${descriptionTitle}`;
            tabsContainer.insertBefore(newHeader, firstHeader); // Insert the new header before the first <h5>

            // Create container for initial content
            initialContentContainer = document.createElement('div');
            initialContentContainer.classList.add('content-container');

            // Move all nodes before the first h5 into the initial content container
            firstChild = tabsContainer.firstChild;
            while (firstChild && firstChild !== newHeader) {
                const nextSibling = firstChild.nextSibling;
                initialContentContainer.appendChild(firstChild);
                firstChild = nextSibling;
            }

            tabsContainer.insertBefore(initialContentContainer, newHeader.nextSibling); // Insert the content container

            // Initially hide the content container
            initialContentContainer.style.display = 'none';

            // Add click event to toggle content visibility
            newHeader.addEventListener('click', () => {
                toggleContent(newHeader, initialContentContainer);
            });
        }
    }

    // Add event listeners to all existing h5 headers
    document.querySelectorAll('.mr-pp-tabs h5').forEach(header => {
        header.addEventListener('click', () => {
            toggleTab(header);
        });
    });

    function hideAllContentContainers() {
        document.querySelectorAll('.content-container').forEach(container => {
            container.style.display = 'none';
            container.classList.remove('show');
        });

        document.querySelectorAll('h5').forEach(h5 => {
            h5.classList.remove('selected');
            h5.querySelector('.symbol').textContent = '+';
        });
    }

    function toggleTab(header) {
        const nextElement = header.nextElementSibling;
        if (nextElement && nextElement.classList.contains('content-container') && nextElement.style.display === 'block') {
            // If the current tab is open, close it
            nextElement.style.display = 'none';
            nextElement.classList.remove('show');
            header.classList.remove('selected');
            header.querySelector('.symbol').textContent = '+';
        } else {
            // Otherwise, open the tab and hide all others
            hideAllContentContainers();
            showContent(header);
        }
    }

    function toggleContent(header, container) {
        if (container.style.display === 'block') {
            container.style.display = 'none';
            container.classList.remove('show');
            header.classList.remove('selected');
            header.querySelector('.symbol').textContent = '+';
        } else {
            hideAllContentContainers();
            container.style.display = 'block';
            container.classList.add('show');
            header.classList.add('selected');
            header.querySelector('.symbol').textContent = '-';
        }
    }

    function showContent(header) {
        header.classList.add('selected');
        header.querySelector('.symbol').textContent = '-';
        let nextElement = header.nextSibling;

        // Create a new container for this header's content if it doesn't already exist
        let container = header.nextElementSibling;
        if (!container || !container.classList.contains('content-container')) {
            container = document.createElement('div');
            container.classList.add('content-container');
            header.parentNode.insertBefore(container, header.nextSibling);

            // Move all elements until the next h5 into the container
            while (nextElement && !(nextElement.nodeType === 1 && nextElement.tagName.toLowerCase() === 'h5')) {
                const sibling = nextElement.nextSibling;
                container.appendChild(nextElement);
                nextElement = sibling;
            }
        }

        container.style.display = 'block';
        container.classList.add('show');
    }
});
